package ui
//
//// Note: This assumes you have the existing Dashboard components (DashboardIcon, ListingsIcon, etc.)
//// and SidebarItem component from the previous conversion
//
//import dataInquiries
//import js.objects.jso
//import react.*
//import react.dom.html.ReactHTML.button
//import react.dom.html.ReactHTML.div
//import react.dom.html.ReactHTML.h1
//import react.dom.html.ReactHTML.h2
//import react.dom.html.ReactHTML.img
//import react.dom.html.ReactHTML.span
//import routes.EnumRoutes
//import ui.components.CloseIcon
//import ui.components.DashboardIcon
//import ui.components.DataSidebarMenu
//import ui.components.InquiriesIcon
//import ui.components.ListingsIcon
//import ui.components.MenuIcon
//import ui.components.NavBar
//import ui.components.OwnerSubmissionsIcon
//import ui.components.ScheduleIcon
//import web.cssom.*
//
//// New Props interfaces for Inquiries page
//external interface TabItemProps : Props {
//    var label: String
//    var isActive: Boolean?
//    var onClick: (() -> Unit)?
//}
//
//external interface InquiryRowProps : Props {
//    var name: String
//    var property: String
//    var type: String
//    var email: String
//    var status: String
//    var avatar: String
//}
//
//external interface InquiryData {
//    var name: String
//    var property: String
//    var type: String
//    var email: String
//    var status: String
//    var avatar: String
//}
//
//// TabItem Component
//val TabItem = FC<TabItemProps> { props ->
//    button {
//        onClick = { props.onClick?.invoke() }
//        className = ClassName(
//            "py-3 text-sm font-normal transition-colors " +
//                    if (props.isActive == true) {
//                        "text-black border-b border-black"
//                    } else {
//                        "text-boon-gray hover:text-black"
//                    }
//        )
//        +props.label
//    }
//}
//
//// InquiryRow Component
//val InquiryRow = FC<InquiryRowProps> { props ->
//    div {
//        className = ClassName("flex justify-center items-start gap-4 border-b border-gray-200 py-4")
//
//        // Name column
//        div {
//            className = ClassName("flex-1 flex items-center gap-3")
//            img {
//                src = props.avatar
//                alt = props.name
//                className = ClassName("w-8 h-8 rounded-full")
//            }
//            div {
//                className = ClassName("text-sm font-normal text-black")
//                style = jso<CSSProperties> {
//                    fontFamily = string("Century Schoolbook, serif")
//                }
//                +props.name
//            }
//        }
//
//        // Property column
//        div {
//            className = ClassName("flex-1 flex items-center")
//            div {
//                className = ClassName("text-sm font-normal text-black")
//                style = jso<CSSProperties> {
//                    fontFamily = string("Century Schoolbook, serif")
//                }
//                +props.property
//            }
//        }
//
//        // Type column
//        div {
//            className = ClassName("w-28 flex items-center")
//            div {
//                className = ClassName("text-sm font-normal text-black")
//                style = jso<CSSProperties> {
//                    fontFamily = string("Century Schoolbook, serif")
//                }
//                +props.type
//            }
//        }
//
//        // Email column
//        div {
//            className = ClassName("flex-1 flex items-center")
//            div {
//                className = ClassName("text-sm font-normal text-black")
//                style = jso<CSSProperties> {
//                    fontFamily = string("Century Schoolbook, serif")
//                }
//                +props.email
//            }
//        }
//
//        // Status column
//        div {
//            className = ClassName("flex-1 flex items-center")
//            div {
//                className = ClassName("text-sm font-normal text-black")
//                style = jso<CSSProperties> {
//                    fontFamily = string("Century Schoolbook, serif")
//                }
//                +props.status
//            }
//        }
//    }
//}
//
//// Main Inquiries Component
//val Inquiries = FC<Props> {
//    var isSidebarOpen by useState(false)
//    var activeTab by useState("All")
//
//    // Inquiries data
//    val inquiriesData = dataInquiries
//
//    div {
//        className = ClassName("min-h-screen bg-white flex relative")
//
//        // Mobile Menu Button
//        button {
//            className = ClassName("lg:hidden fixed top-4 left-4 z-50 bg-boon-primary text-white p-2 rounded-lg")
//            onClick = { isSidebarOpen = !isSidebarOpen }
//
//            if (isSidebarOpen) {
//                createElement(CloseIcon)
//            } else {
//                createElement(MenuIcon)
//            }
//        }
//
////        Side Navigation
//        NavBar{
//            this.activeNavItem = "Inquiries"
//            this.sidebarItemsList = arrayListOf(
//                DataSidebarMenu(
//                    icon = createElement(DashboardIcon),
//                    label = "Dashboard",
//                    to = EnumRoutes.Dashboard.routeID,
//
//                    ),
//                DataSidebarMenu(
//                    icon = createElement(ListingsIcon),
//                    label = "Properties",
//                    to = EnumRoutes.Properties.routeID
//                ),
//                DataSidebarMenu(
//                    icon = createElement(OwnerSubmissionsIcon),
//                    label = "Owner Submissions",
//                    to = EnumRoutes.OwnerSubmissions.routeID
//                ),
//                DataSidebarMenu(
//                    icon = createElement(InquiriesIcon),
//                    label = "Inquiries",
//                    to = EnumRoutes.PropertyInquiries.routeID),
//                DataSidebarMenu(
//                    icon = createElement(ScheduleIcon),
//                    label = "Visit Scheduler",
//                    to = EnumRoutes.ScheduledVisit.routeID
//                ))
//        }
//
//        // Main Content
//        div {
//            className = ClassName("flex-1 p-4 lg:p-6 ml-0 lg:ml-0")
//
//            // Breadcrumb
//            div {
//                className = ClassName("flex items-center gap-2 mb-6 mt-16 lg:mt-0")
//                button {
//                    className = ClassName("text-sm font-normal text-black hover:text-boon-primary")
//                    onClick = {
//                        // Handle navigation to Dashboard
//                        console.log("Navigate to Dashboard")
//                    }
//                    +"Dashboard"
//                }
//                span {
//                    className = ClassName("text-sm font-normal text-boon-gray")
//                    +">"
//                }
//                span {
//                    className = ClassName("text-sm font-normal text-black")
//                    +"Inquiries"
//                }
//            }
//
//            // Page Title
//            div {
//                className = ClassName("text-center mb-6")
//                h1 {
//                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
//                    +"Inquiries"
//                }
//            }
//
//            // Tab Navigation
//            div {
//                className = ClassName("flex items-start gap-5 border-b border-gray-200 mb-6")
//
//                TabItem {
//                    label = "All"
//                    isActive = (activeTab == "All")
//                    onClick = { activeTab = "All" }
//                }
//                TabItem {
//                    label = "New"
//                    isActive = (activeTab == "New")
//                    onClick = { activeTab = "New" }
//                }
//                TabItem {
//                    label = "Responded"
//                    isActive = (activeTab == "Responded")
//                    onClick = { activeTab = "Responded" }
//                }
//                TabItem {
//                    label = "Archived"
//                    isActive = (activeTab == "Archived")
//                    onClick = { activeTab = "Archived" }
//                }
//            }
//
//            // Recent Inquiries Title
//            div {
//                className = ClassName("text-center mb-6")
//                h2 {
//                    className = ClassName("text-lg lg:text-xl font-normal text-black")
//                    +"Recent Inquiries"
//                }
//            }
//
//            // Inquiries Data
//            div {
//                className = ClassName("space-y-0")
//
//                inquiriesData.forEach { inquiry ->
//                    InquiryRow {
//                        name = "${inquiry.firstName} ${inquiry.lastName}"
//                        property = inquiry.propertyId.toString()
//                        type = inquiry.inquiryType.toString()
//                        email = inquiry.email.toString()
//                        status = inquiry.status.toString()
////                        avatar = inquiry.avatar
//                    }
//                }
//            }
//        }
//    }
//}

import js.objects.jso
import react.*
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.textarea
import react.router.dom.Link
import react.router.useNavigate
import kotlinx.browser.window
import routes.EnumRoutes
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import web.cssom.*


external interface TabItemProps : Props {
    var label: String
    var isActive: Boolean?
    var onClick: (() -> Unit)?
}

val TabItem = FC<TabItemProps> { props ->
    button {
        onClick = { props.onClick?.invoke() }
        className = ClassName(
            "py-3 text-sm font-normal transition-colors " +
                    if (props.isActive == true) "text-black border-b border-black"
                    else "text-boon-gray hover:text-black"
        )
        +props.label
    }
}

data class InquiryData(
    val name: String,
    val property: String,
    val type: String,
    val email: String,
    val status: String,
    val avatar: String
)

external interface InquiryRowProps : Props {
    var name: String
    var property: String
    var type: String
    var email: String
    var status: String
    var avatar: String
    var onClick: (() -> Unit)?
}

val InquiryRow = FC<InquiryRowProps> { props ->
    button {
        onClick = { props.onClick?.invoke() }
        className = ClassName("w-full text-left")

        div {
            className = ClassName("flex justify-center items-start gap-4 border-b border-gray-200 py-4 hover:bg-gray-50")

            div {
                className = ClassName("flex-1 flex items-center gap-3")
                img {
                    src = props.avatar
                    alt = props.name
                    className = ClassName("w-8 h-8 rounded-full")
                }
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.name
                }
            }

            div {
                className = ClassName("flex-1 flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.property
                }
            }

            div {
                className = ClassName("w-28 flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.type
                }
            }

            div {
                className = ClassName("flex-1 flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.email
                }
            }

            div {
                className = ClassName("flex-1 flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.status
                }
            }
        }
    }
}

val inquiriesDataInitial = listOf(
    InquiryData(
        name = "Priya Singh",
        property = "3BHK, Lakeview",
        type = "Renter",
        email = "priyasingh@email.com",
        status = "Approved",
        avatar = "https://api.builder.io/api/v1/image/assets/TEMP/6c013e24db310da4c4498a7f0b0e15b4efbf529d"
    ),
    InquiryData(
        name = "John Doe",
        property = "2BHK, Green Acres",
        type = "Buyer",
        email = "johndoe@email.com",
        status = "Pending",
        avatar = "https://api.builder.io/api/v1/image/assets/TEMP/6c013e24db310da4c4498a7f0b0e15b4efbf529d"
    ),
    InquiryData(
        name = "Amit Patel",
        property = "Studio, City Center",
        type = "Buyer",
        email = "amitpatel@email.com",
        status = "Approved",
        avatar = "https://api.builder.io/api/v1/image/assets/TEMP/4ce3f5bfa678abdf84ab555adb7cdf99651f5f1c"
    ),
    InquiryData(
        name = "Sarah Khan",
        property = "1BHK, Riverside",
        type = "Renter",
        email = "sarahkhan@email.com",
        status = "Pending",
        avatar = "https://api.builder.io/api/v1/image/assets/TEMP/4ce3f5bfa678abdf84ab555adb7cdf99651f5f1c"
    )
)

val Inquiries = FC<Props> {
    var isSidebarOpen by useState(false)
    var activeTab by useState("All")
    var inquiries by useState(inquiriesDataInitial)
    var selectedInquiry by useState<InquiryData?>(null)
    var responseText by useState("")
    var responseMessage by useState<String?>(null)
    var selectedStatus by useState("")

    useEffect(selectedInquiry) {
        selectedInquiry?.let {
            selectedStatus = it.status
        } ?: run {
            selectedStatus = ""
        }
    }

    val handleSendResponse = {
        selectedInquiry?.let { inquiry ->
            inquiries = inquiries.map {
                if (it.email == inquiry.email) {
                    it.copy(status = selectedStatus.ifEmpty { it.status })
                } else it
            }
            responseMessage = "Response sent"
            responseText = ""
            window.setTimeout({
                responseMessage = null
            }, 3000)
        }
    }

    div {
        className = ClassName("min-h-screen bg-white flex relative")

        // Mobile Menu Button
        button {
            className = ClassName("lg:hidden fixed top-4 left-4 z-50 bg-boon-primary text-white p-2 rounded-lg")
            onClick = { isSidebarOpen = !isSidebarOpen }
            if (isSidebarOpen) {
                +"✕" // CloseIcon placeholder
            } else {
                +"☰" // MenuIcon placeholder
            }
        }

        // Sidebar
        div {
            className = ClassName(
                "fixed lg:static inset-y-0 left-0 z-40 w-80 bg-boon-bg-light flex flex-col " +
                        "transform ${if (isSidebarOpen) "translate-x-0" else "-translate-x-full"} " +
                        "lg:translate-x-0 transition-transform duration-300 ease-in-out"
            )

            // Logo
            div {
                className = ClassName("flex justify-center p-6 mt-12 lg:mt-0")
                img {
                    src = "https://api.builder.io/api/v1/image/assets/TEMP/8476af9399157c36bdeb92434c79697dd7909f64"
                    alt = "Boon Logo"
                    className = ClassName("w-24 h-28")
                }
            }

            // Navigation
            NavBar{
                this.activeNavItem = "Inquiries"
            }
        }

        // Main Content
        div {
            className = ClassName("flex-1 p-4 lg:p-6 ml-0 lg:ml-0")

            // Page Title
            div {
                className = ClassName("text-center mb-6")
                h1 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
                    +"Inquiries"
                }
            }

            // Tab Navigation
            div {
                className = ClassName("flex items-start gap-5 border-b border-gray-200 mb-6")
                TabItem {
                    label = "All"
                    isActive = activeTab == "All"
                    onClick = { activeTab = "All" }
                }
                TabItem {
                    label = "New"
                    isActive = activeTab == "New"
                    onClick = { activeTab = "New" }
                }
                TabItem {
                    label = "Responded"
                    isActive = activeTab == "Responded"
                    onClick = { activeTab = "Responded" }
                }
                TabItem {
                    label = "Archived"
                    isActive = activeTab == "Archived"
                    onClick = { activeTab = "Archived" }
                }
            }

            // Recent Inquiries Title
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-lg lg:text-xl font-normal text-black")
                    +"Recent Inquiries"
                }
            }

            // Inquiries Data
            div {
                className = ClassName("space-y-0")
                inquiries.forEach { inquiry ->
                    InquiryRow {
                        name = inquiry.name
                        property = inquiry.property
                        type = inquiry.type
                        email = inquiry.email
                        status = inquiry.status
                        avatar = inquiry.avatar
                        onClick = { selectedInquiry = inquiry }
                    }
                }
            }

            // Slide-over Respond Panel
            selectedInquiry?.let { inquiry ->
                div {
                    className = ClassName("fixed inset-y-0 right-0 z-50 w-full lg:w-1/3 bg-white shadow-lg p-6 overflow-auto")

                    div {
                        className = ClassName("flex items-start justify-between mb-4")
                        div {
                            h3 {
                                className = ClassName("text-lg font-semibold text-black")
                                +"Respond to Inquiry"
                            }
                            div {
                                className = ClassName("text-sm text-boon-gray")
                                +"from ${inquiry.name} · ${inquiry.email}"
                            }
                        }
                        div {
                            button {
                                onClick = { selectedInquiry = null }
                                className = ClassName("text-sm text-boon-gray")
                                +"Close"
                            }
                        }
                    }

                    div {
                        className = ClassName("mb-4")

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Property"
                        }
                        div {
                            className = ClassName("text-sm text-black mb-2")
                            +inquiry.property
                        }

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Type"
                        }
                        div {
                            className = ClassName("text-sm text-black mb-2")
                            +inquiry.type
                        }

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Current Status"
                        }
                        div {
                            className = ClassName("text-sm text-black mb-2")
                            +inquiry.status
                        }

                        div {
                            className = ClassName("mt-3")
                            label {
                                className = ClassName("text-sm font-normal mb-2 block")
                                +"Change Status"
                            }
                            select {
                                value = selectedStatus
                                onChange = { e -> selectedStatus = e.target.value }
                                className = ClassName("w-full bg-[#F8F8F7] rounded-lg px-4 py-3 text-sm text-[#949494] outline-none")

                                option { value = "Pending"; +"Pending" }
                                option { value = "Approved"; +"Approved" }
                                option { value = "Responded"; +"Responded" }
                                option { value = "Archived"; +"Archived" }
                            }
                        }
                    }

                    div {
                        className = ClassName("mb-4")
                        label {
                            className = ClassName("text-sm font-normal mb-2 block")
                            +"Response"
                        }
                        textarea {
                            value = responseText
                            onChange = { e -> responseText = e.target.value }
                            className = ClassName("w-full h-40 bg-[#F8F8F7] rounded-lg px-4 py-3 text-sm text-[#949494] outline-none resize-none")
                            placeholder = "Write your response to the inquiry here..."
                        }
                    }

                    div {
                        className = ClassName("flex items-center gap-3")
                        button {
                            onClick = { handleSendResponse() }
                            className = ClassName("bg-boon-primary text-white px-4 py-2 rounded-xl text-sm font-normal")
                            +"Send Response"
                        }
                        button {
                            onClick = {
                                selectedInquiry = null
                                responseText = ""
                            }
                            className = ClassName("bg-gray-100 text-black px-4 py-2 rounded-xl text-sm font-normal")
                            +"Close"
                        }
                        responseMessage?.let { msg ->
                            div {
                                className = ClassName("text-sm text-green-700")
                                +msg
                            }
                        }
                    }
                }
            }
        }
    }
}